export const LANGUAGES = {
  ja: '日本語',
  en: 'English',
  vi: 'Tiếng Việt',
  my: 'မြန်မာ',
  fr: 'Français',
} as const

export type LanguageCode = keyof typeof LANGUAGES

export const DEFAULT_LANGUAGE: LanguageCode = 'ja'

export const SUPPORTED_LANGUAGES: LanguageCode[] = Object.keys(
  LANGUAGES,
) as LanguageCode[]

export const LANGUAGE_STORAGE_KEY = 'kansei-app-language'
